export const ALLOWED_FILE_SIZE = 5000000;
export const ALLOWED_IMAGE_FILE = ['.jpg', '.jpeg', '.png'];
export const ALLOWED_PDF_FILE = ['.pdf'];
export const ALLOWED_EXCEL_FILE = ['.xls', '.xlsx'];